var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-value flex flex-ali-center"},[_c('div',{staticClass:"label h100",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label)+_vm._s(_vm.symbol))]),_c('div',{staticClass:"value flex1 h100"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }